import React from 'react'

import { IntroVideo } from './components/IntroVideo'
import { IntroFaqs } from './components/IntroFaqs'
import { Container } from '@/components'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { TextBreak } from '@/components/TextBreak'
import useNewPlanUI from '@/lib/utils/newPlan'

const FeatureSectionWrapper = styled.section<{ color?: string }>`
	background-color: ${({ color }) => (color ? color : 'transparent')};

	.container {
		height: 100%;
	}
`

const FaqSectionWrapper = styled.section`
	background: #f5f8fb;
`

const SectionTRPanel = styled.div<{ position?: string; image?: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: ${({ position }) => (position ? 'flex-' + position : 'center')};
	height: 100%;
	line-height: 1.5;
	background: no-repeat 50% 50% / cover;
	background-image: ${({ image }) => (image ? 'url(' + image + ')' : 'none')};
	background-position: ${({ position }) =>
		position === 'start'
			? 'right center'
			: position === 'end'
			? 'left center'
			: 'center center'};
	background-size: contain;

	.panel_inner {
		height: 100%;
		text-align: ${({ position }) => (position ? 'left' : 'center')};
		padding-top: 80px;
		padding-left: ${({ position }) => (position === 'end' ? '24px' : 0)};

		p {
			letter-spacing: -0.25px;
		}

		.title {
			font-size: 48px;
			font-weight: bold;
			color: ${themeGet('text.0', '#1B1B29')};
			word-break: keep-all;
			margin: 0;
		}

		.desc {
			font-size: 32px;
			color: ${themeGet('text.0', '#1B1B29')};
			margin-top: 16px;
			margin-bottom: 0;
		}

		img {
			margin-top: 48px;
		}

		@media (max-width: 1200px) {
			padding-top: 64px;

			.title {
				font-size: 36px;
			}
			.desc {
				font-size: 28px;
				margin-top: 8px;
			}
			img {
				width: 90%;
				max-width: 500px;
			}
		}
		@media (max-width: 768px) {
			width: inherit;
			padding-top: 48px;

			.title {
				font-size: 28px;
				text-shadow: 0 0 5px rgb(255 255 255);

				br {
					display: none;
				}
			}
			.desc {
				font-size: 20px;
				text-shadow: 0 0 5px rgb(255 255 255);
			}
			img {
				margin-top: 24px;
			}
		}
	}

	@media (max-width: 1200px) {
		padding: 0 20px;
	}
	@media (max-width: 768px) {
		padding: 0;
	}
`

const FaqWrapper = styled.div`
	letter-spacing: -0.25px;
	padding: 80px 0 150px;

	.title {
		font-size: 24px;
		font-weight: bold;
		color: ${themeGet('text.0', '#1B1B29')};
		margin-bottom: 40px;
	}

	@media (max-width: 1200px) {
		padding-left: 20px;
		padding-right: 20px;

		.title {
			font-size: 20px;
			margin-bottom: 24px;
		}
	}
	@media (max-width: 768px) {
		padding: 36px 0 48px;

		.title {
			font-size: 16px;
			margin-bottom: 12px;
		}
	}
`

export const IntroducePage: React.FC<{}> = ({}) => {
	// TODO New 요금제 : 사업부에서 추가 내용 수급 필요

	const faqs = useNewPlanUI().useNewPlan
		? [
				{
					title: '쏠북에서는 왜 저작권 문제가 없나요?',
					id: 1,
					content: (
						<div style={{ lineHeight: '1.5' }}>
							<div>
								쏠북은 출판사가 정식으로 출판사의 콘텐츠에 대한 이용 권리를 허가한
								국내 유일의 디지털 교재 플랫폼입니다.
								<TextBreak /> 라이선싱 거래는 이용 권리에 대한 거래를 뜻합니다.
							</div>
							<div style={{ marginTop: '10px' }}>
								쏠북에서 이용권리를 거래하시면, 즉, 수업콘텐츠 라이선스를
								계약하시면,
								<TextBreak /> 저작자의 정식 허락 하에 수업 전송, 자료 저작 등 교재에
								기반한 다양한 교육활동을 마음껏 할 수 있습니다.
							</div>
							<div style={{ marginTop: '10px' }}>
								- 저작자의 권리 보호를 위해 수업콘텐츠를 쏠북 플랫폼 뷰어를 통해
								제공합니다.
								<TextBreak />
								- 다양한 교육활동을 편리하게 할 수 있도록 편집툴, 마켓 등의 기능을
								제공합니다.
								<TextBreak />- 교재의 단순 복제나 전체 인쇄는 저작권자의 허락 범위
								내에 있지 않은 경우가 많으니 꼭 참고해주세요.
							</div>
						</div>
					),
				},
				{
					title: '수업콘텐츠 라이선스 계약 후, 파일로 다운로드할 수 있나요?',
					id: 3,
					content: (
						<div style={{ lineHeight: '1.5' }}>
							수업콘텐츠 라이선스를 계약하신 후, 쏠북 플랫폼 뷰어로 콘텐츠를 확인 및
							이용하실 수 있습니다.
							<TextBreak />
							쏠북은 저작권자의 권리 보호를 위해 쏠북 플랫폼 뷰어를 제공하므로,
							<TextBreak />
							쏠북에 접속 시 언제든지 어디서나 편리하게 이용할 수 있습니다.
						</div>
					),
				},
		  ]
		: [
				{
					title: '쏠북에서는 왜 저작권 문제가 없나요?',
					id: 1,
					content: (
						<div style={{ lineHeight: '1.5' }}>
							<div>
								쏠북은 출판사가 정식으로 출판사의 콘텐츠에 대한 이용 권리를 허가한
								국내 유일의 디지털 교재 플랫폼입니다.
								<TextBreak /> 라이선싱 거래는 이용 권리에 대한 거래를 뜻합니다.
							</div>
							<div style={{ marginTop: '10px' }}>
								쏠북에서 이용권리를 거래하시면, 즉, 수업콘텐츠 라이선스를
								계약하시면,
								<TextBreak /> 저작자의 정식 허락 하에 수업 전송, 자료 저작 등 교재에
								기반한 다양한 교육활동을 마음껏 할 수 있습니다.
							</div>
							<div style={{ marginTop: '10px' }}>
								- 저작자의 권리 보호를 위해 수업콘텐츠를 쏠북 플랫폼 뷰어를 통해
								제공합니다.
								<TextBreak />
								- 다양한 교육활동을 편리하게 할 수 있도록 편집툴, 마켓 등의 기능을
								제공합니다.
								<TextBreak />- 교재의 단순 복제나 전체 인쇄는 저작권자의 허락 범위
								내에 있지 않은 경우가 많으니 꼭 참고해주세요.
							</div>
						</div>
					),
				},
				{
					title: '라이트/베이직/프로 라이선스 프로그램은 어떤 차이가 있나요?',
					id: 2,
					content: (
						<div style={{ lineHeight: '1.5' }}>
							<div>
								1. 각 라이선스 프로그램 수업콘텐츠를 이용하는 선생님과 학생 수에
								따라 나뉘어 있습니다.
								<TextBreak />
								<div style={{ margin: '10px 0' }}>
									※ 예를 들어, 선생님께서 [라이트] 수업콘텐츠 라이선스를
									계약했다면, <br />
									선생님을 제외한 4명의 학생에게 공유를 하거나, 출력하여 나눠줄 수
									있습니다.
								</div>
								<TextBreak />
								- 라이트 : 선생님과 학생 최대 5명까지 이용할 수 있습니다.
								<TextBreak />
								- 베이직 : 선생님과 학생 최대 100명까지 이용할 수 있습니다.
								<TextBreak />
								- 프로 : 선생님과 학생 최대 500명까지 이용할 수 있습니다.
								<TextBreak />
							</div>
							<div style={{ marginTop: '10px' }}>
								2. 제공되는 수업콘텐츠 라이선스의 내용과 이용 범위는 프로그램 종류와
								상관없이 동일합니다.
							</div>
						</div>
					),
				},
				{
					title: '수업콘텐츠 라이선스 계약 후, 파일로 다운로드할 수 있나요?',
					id: 3,
					content: (
						<div style={{ lineHeight: '1.5' }}>
							수업콘텐츠 라이선스를 계약하신 후, 쏠북 플랫폼 뷰어로 콘텐츠를 확인 및
							이용하실 수 있습니다.
							<TextBreak />
							쏠북은 저작권자의 권리 보호를 위해 쏠북 플랫폼 뷰어를 제공하므로,
							<TextBreak />
							쏠북에 접속 시 언제든지 어디서나 편리하게 이용할 수 있습니다.
						</div>
					),
				},
				{
					title: '슬롯이 무엇인가요?',
					id: 4,
					content: (
						<div style={{ lineHeight: '1.5' }}>
							쏠북은 구매하신 수업콘텐츠 라이선스에 대해 이용할 수 있는 선생님·학생수
							이며, 이용 횟수와는 다릅니다.
							<TextBreak />
							예를 들어 선생님이 수업콘텐츠를 뷰어로 최초 열었을 때 또는 학생을
							등록했을 때 최초 1회씩 슬롯이 차감되며,
							<TextBreak />
							선생님이 뷰어를 다시 열거나, 이미 등록한 학생을 위한 추가 인쇄를 할
							때에는 슬롯이 차감되지 않습니다.
						</div>
					),
				},
		  ]

	return (
		<>
			<IntroVideo />

			<FaqSectionWrapper>
				<Container>
					<FaqWrapper>
						<p className={'title'}>자주 묻는 질문</p>
						<IntroFaqs faqs={faqs} />
					</FaqWrapper>
				</Container>
			</FaqSectionWrapper>
		</>
	)
}
